"use client";

import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from "embla-carousel-react";
import React from "react";
import { twMerge } from "tailwind-merge";
import { EmblaCarouselProps } from "@/TS/Interfaces/global_interfaces";
import { NextButton, PrevButton, usePrevNextButtons } from "./embla-carousel-arrow-buttons";
import { DotButton, useDotButton } from "./embla-carousel-dot-button";
export function EmblaCarousel(props) {
  const $ = _c(33);
  const [emblaRef, emblaApi] = useEmblaCarousel(props.options);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi);
  const {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick
  } = useDotButton(emblaApi);
  const t0 = `embla__container ${props.containerClassName}`;
  let t1;
  if ($[0] !== t0) {
    t1 = twMerge(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.children || $[3] !== selectedIndex) {
    let t3;
    if ($[5] !== selectedIndex) {
      t3 = (child, index) => <div className={`embla__slide ${index === selectedIndex ? "is-selected" : "is-not-selected"}`}>{child}</div>;
      $[5] = selectedIndex;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = React.Children.map(props.children, t3);
    $[2] = props.children;
    $[3] = selectedIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onPrevButtonClick || $[11] !== prevBtnDisabled) {
    t4 = <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />;
    $[10] = onPrevButtonClick;
    $[11] = prevBtnDisabled;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== onDotButtonClick || $[14] !== scrollSnaps || $[15] !== selectedIndex) {
    let t6;
    if ($[17] !== onDotButtonClick || $[18] !== selectedIndex) {
      t6 = (_, index_0) => <DotButton key={index_0} onClick={() => onDotButtonClick(index_0)} className={"embla__dot".concat(index_0 === selectedIndex ? " embla__dot--selected" : "")} />;
      $[17] = onDotButtonClick;
      $[18] = selectedIndex;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t5 = scrollSnaps.map(t6);
    $[13] = onDotButtonClick;
    $[14] = scrollSnaps;
    $[15] = selectedIndex;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[20] !== t5) {
    t6 = <div className="embla__dots">{t5}</div>;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== nextBtnDisabled || $[23] !== onNextButtonClick) {
    t7 = <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />;
    $[22] = nextBtnDisabled;
    $[23] = onNextButtonClick;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t4 || $[26] !== t6 || $[27] !== t7) {
    t8 = <div className="embla__controls"><div className="embla__buttons">{t4}{t6}{t7}</div></div>;
    $[25] = t4;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== emblaRef || $[30] !== t3 || $[31] !== t8) {
    t9 = <div className="embla" ref={emblaRef}>{t3}{t8}</div>;
    $[29] = emblaRef;
    $[30] = t3;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}